const app = {
  state: {
    sidebar: {
      opened: true,
      hiddenSidebar: true
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: (state, data) => {
      state.sidebar.opened = data;
    },
    // 设置左侧菜单是否显示或隐藏
    SIDEBAR_DISPLAYSTATUS: (state, data) => {
      state.sidebar.hiddenSidebar = data;
    }
  },
  actions: {
    toggleSidebar({ state, commit }) {
      commit("TOGGLE_SIDEBAR", !state.sidebar.opened);
    },
    // 设置左侧菜单是否显示或隐藏
    setSidebarDisplayStatus({ commit }, data) {
      commit("SIDEBAR_DISPLAYSTATUS", data);
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js